import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="inline-name-edit"
export default class extends Controller {
  static targets = ["display", "form", "input", "error"]

  connect() {
  }

  edit(event) {
    event.preventDefault()
    this.displayTarget.classList.add("d-none")
    this.formTarget.classList.remove("d-none")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel(event) {
    event.preventDefault()
    this.hideForm()
  }

  async save(event) {
    event.preventDefault()

    const formData = new FormData()
    formData.append("full_name", this.inputTarget.value)

    try {
      const response = await fetch(this.formTarget.action, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
          "Accept": "application/json"
        },
        body: formData
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Update the display text with the new name
        this.displayTarget.querySelector("h1").textContent = data.full_name
        this.hideForm()
        if (this.hasErrorTarget) {
          this.errorTarget.textContent = ""
          this.errorTarget.classList.add("d-none")
        }
      } else {
        // Show error message
        if (this.hasErrorTarget) {
          this.errorTarget.textContent = data.errors ? data.errors.join(", ") : "An error occurred"
          this.errorTarget.classList.remove("d-none")
        }
      }
    } catch (error) {
      console.error("Error updating name:", error)
      if (this.hasErrorTarget) {
        this.errorTarget.textContent = "An error occurred while updating your name"
        this.errorTarget.classList.remove("d-none")
      }
    }
  }

  hideForm() {
    this.formTarget.classList.add("d-none")
    this.displayTarget.classList.remove("d-none")
    // Reset input to current display value
    this.inputTarget.value = this.displayTarget.querySelector("h1").textContent
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("d-none")
    }
  }
}
